module.exports = __webpack_public_path__ + "static/media/dealW.fab7816a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/dealW.svg
// module id = 558
// module chunks = 0